import { useEffect, useState } from 'react';

const EMPTY = {
  idPersona: 0,
  correo: '',
  esPrincipal: false,
};

export default function Modal({
  open,
  mode = 'new',
  data = null,
  onClose,
  onSubmit,
  inline = false,
}) {
  const [form, setForm] = useState(EMPTY);

  useEffect(() => {
    if (mode === 'edit' && data) {
      setForm({
        idCorreo: data.idCorreo ?? 0,
        idPersona: data.idPersona ?? 0,
        correo: data.correo ?? '',
        esPrincipal: !!data.esPrincipal,
      });
    } else {
      setForm(EMPTY);
    }
  }, [mode, data]);

  if (!open) return null;

  const Header = (
    <div
      className="roles-topbar"
      style={{
        marginBottom: '0.6rem',
        paddingRight: 16,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        flex: '0 0 auto',
      }}>
      <h3 className="roles-title" style={{ marginRight: 0 }}>
        {mode === 'new' ? 'Nuevo correo' : 'Editar correo'}
      </h3>
      <button className="roles-btn" onClick={onClose} aria-label="Cerrar">✕</button>
    </div>
  );

  const Body = (
    <div
      style={{
        paddingLeft: '12%',
        paddingRight: 16,
        display: 'grid',
        gridTemplateColumns: '1fr 1fr',
        gap: '0.8rem',
        overflowY: 'auto',
        flex: '1 1 auto',
        minHeight: 0,
      }}>

      {/* ID Persona */}
      <div>
        <label className="roles-title" style={{ fontSize: '.95rem' }}>ID Persona:</label>
        <br /><br />
        <input
          className="infoField"
          type="number"
          min={1}
          value={form.idPersona}
          onChange={(e) =>
            setForm({
              ...form,
              idPersona: Number(e.target.value) || 0,
            })
          }
        />
      </div>

      {/* Correo */}
      <div>
        <label className="roles-title" style={{ fontSize: '.95rem' }}>Correo:</label>
        <br /><br />
        <input
          className="infoField"
          type="email"
          value={form.correo}
          onChange={(e) =>
            setForm({
              ...form,
              correo: e.target.value,
            })
          }
          maxLength={150}
        />
      </div>

      {/* Principal */}
      <div style={{ gridColumn: '1 / 3' }}>
        <label className="roles-title" style={{ fontSize: '.95rem' }}>
          <input
            type="checkbox"
            checked={form.esPrincipal}
            onChange={(e) =>
              setForm({
                ...form,
                esPrincipal: e.target.checked,
              })
            }
            style={{ marginRight: '.5rem' }}
          />
          Principal
        </label>
      </div>
    </div>
  );

  const Footer = (
    <div
      style={{
        display: 'flex',
        justifyContent: 'flex-end',
        gap: '.6rem',
        marginTop: '.8rem',
        paddingRight: 16,
        flex: '0 0 auto',
      }}
    >
      <button className="roles-btn" onClick={onClose}>Cancelar</button>
      <button
        className="btn-action"
        onClick={() => onSubmit(form, mode)}
        disabled={
          !form.idPersona ||
          !form.correo?.trim()
        }
      >
        {mode === 'new' ? 'Guardar' : 'Actualizar'}
      </button>
    </div>
  );

  if (inline) {
    return (
      <div className="roles-inline-card" style={{ display: 'flex', flexDirection: 'column', gap: 0 }}>
        {Header}
        {Body}
        {Footer}
      </div>
    );
  }

  return (
    <div
      className="roles-confirm-overlay"
      role="dialog"
      aria-modal="true"
      style={{
        position: 'fixed',
        inset: 0,
        background: 'rgba(15,23,42,.45)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 16,
        zIndex: 1000,
      }}
      onClick={(e) => { if (e.target === e.currentTarget) onClose?.(); }}
    >
      <div
        className="roles-confirm-card"
        style={{
          width: 'min(900px, 96vw)',
          maxHeight: '85vh',
          background: '#fff',
          borderRadius: 12,
          boxShadow: '0 10px 30px rgba(0,0,0,.25)',
          display: 'flex',
          flexDirection: 'column',
          overflow: 'hidden',
        }}
      >
        {Header}
        {Body}
        {Footer}
      </div>
    </div>
  );
}
